export default __webpack_public_path__ + "static/top-d5354efab2441067a8487cf323c06efb.png";